import React from 'react';
import { Chip } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';
import type { ICellRendererParams } from 'ag-grid-community';

interface StatusCellRendererProps extends ICellRendererParams {
  value: boolean | null | undefined;
}

export const StatusCellRenderer: React.FC<StatusCellRendererProps> = ({ value }) => {
  if (value === null || value === undefined) {
    return (
      <Chip
        label="Unknown"
        size="small"
        variant="outlined"
        sx={{ minWidth: 80 }}
      />
    );
  }

  return (
    <Chip
      icon={value ? <CheckCircle /> : <Error />}
      label={value ? 'Success' : 'Failed'}
      size="small"
      color={value ? 'success' : 'error'}
      variant="filled"
      sx={{ minWidth: 80 }}
    />
  );
};